import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import Draggable from "react-draggable";
import SaveIcon from "@material-ui/icons/Save";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import TextField from "@material-ui/core/TextField";
import { green, orange, red, grey } from "@material-ui/core/colors";
import PropTypes from "prop-types";
import moment from "moment";
import styles from "./QuotaMassEditor.module.css";

const QuotaMassEditor = (props) => {
    const [dateStart, setDateStart] = useState(moment(props.dateStart));
    const [dateEnd, setDateEnd] = useState(moment(props.dateEnd));
    const [massDays, setMassDays] = useState(dateEnd.diff(dateStart, "d"));

    const [isDisabledClose, setIsDisabledClose] = useState(false);
    const [isDisabledOpen, setIsDisabledOpen] = useState(false);

    const handleCheckboxCloseChange = () => {
        setIsDisabledClose((prev) => !prev);
        if (!isDisabledClose) {
            document.getElementById("newQuota").value = "0";
        }
    };

    const handleCheckboxOpenChange = () => {
        setIsDisabledOpen((prev) => !prev);
        if (!isDisabledOpen) {
            document.getElementById("newQuota").value = "0";
        }
    };

    useEffect(() => {
        setMassDays(dateEnd.diff(dateStart, "d"));
    }, [dateStart, dateEnd]);

    const onChangeDateStart = (e) => {
        let newDate = moment(new Date(e.target.value));
        setDateStart(newDate);
    };

    const onChangeDateEnd = (e) => {
        let newDate = moment(new Date(e.target.value));
        setDateEnd(newDate);
    };

    const days = [dateStart.format("YYYY-MM-DD")];
    let daysSet = dateStart.clone();

    if (massDays < 2000) {
        for (let i = 0; i < massDays; i++) {
            days.push(daysSet.add(1, "d").format("YYYY-MM-DD"));
        }
    }

    const inputDate = {
        marginLeft: "5px",
        backgroundColor: "#26ade4",
        color: "white",
        border: "none",
        outline: "none",
        borderRadius: "5px",
        padding: "10px",
        fontFamily: "Roboto",
        fontSize: "15px",
    };

    const newValueCss = {
        marginLeft: "5px",
        border: "none",
        borderBottom: "1px solid pink",
        outline: "none",
        width: "60px",
        fontFamily: "Roboto",
        fontSize: "17px",
    };

    return (
        <div>
            <Dialog
                open={props.isVisible}
                onClose={props.onClose}
                aria-labelledby="draggable-dialog-title"
                maxWidth="xl"
            >
                <DialogTitle
                    style={{ cursor: "move" }}
                    id="draggable-dialog-title"
                >
                    Массовое редактирование квот доступных номеров
                </DialogTitle>
                <form onSubmit={props.onSubmit}>
                    <div style={{ display: "flex" }}>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                minWidth: "40%",
                            }}
                        >
                            {props.roomTypes &&
                                props.roomTypes.map((t) => {
                                    const isAsu = t?.quotas_from_asu;
                                    return (
                                        <div
                                            key={t.id}
                                            className={styles.roomTypeNameContainer}
                                        >
                                            {isAsu ? (
                                                <span
                                                    title="Квоты из АСУ"
                                                    className={styles.exclamationMarkSpan}
                                                >
                                                    !
                                                </span>
                                            ) : (
                                                <input
                                                    className={styles.inputDate}
                                                    type="checkbox"
                                                    id={t.id}
                                                />
                                            )}

                                            <label
                                              htmlFor={t.id}
                                              title={isAsu ? "Квоты из АСУ" : ""}
                                              style={{
                                                  color: isAsu ? "#888" : "inherit",
                                                  cursor: isAsu ? "help" : "pointer",
                                                  userSelect: isAsu ? "none" : "auto"
                                              }}
                                            >
                                                {t.name}
                                            </label>
                                        </div>
                                    );
                                })}
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                padding: "0 10px",
                            }}
                        >
                            <div style={{ marginBottom: "10px" }}>
                                <label htmlFor="dateMassStart">
                                    Дата начала
                                </label>
                                <input
                                    style={inputDate}
                                    onChange={onChangeDateStart}
                                    type="date"
                                    id="dateMassStart"
                                    value={dateStart.format("YYYY-MM-DD")}
                                />
                            </div>
                            <div style={{ marginBottom: "10px" }}>
                                <label htmlFor="dateMassEnd">
                                    Дата окончания
                                </label>
                                <input
                                    style={inputDate}
                                    onChange={onChangeDateEnd}
                                    type="date"
                                    id="dateMassEnd"
                                    value={dateEnd.format("YYYY-MM-DD")}
                                />
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    flexWrap: "wrap",
                                    marginBottom: "10px",
                                }}
                            >
                                {days.map((d) => (
                                    <div
                                        key={d}
                                        style={{
                                            border: "1px solid pink",
                                            borderRadius: "5px",
                                            padding: "5px",
                                            margin: "2px",
                                        }}
                                    >
                                        <input
                                            className={styles.inputDate}
                                            type="checkbox"
                                            id={d}
                                            defaultChecked="true"
                                        />
                                        <label
                                            style={{ marginLeft: "5px" }}
                                            htmlFor={d}
                                        >
                                            {d}
                                        </label>
                                    </div>
                                ))}
                            </div>

                            <div style={{ marginBottom: "10px" }}>
                                <label htmlFor="newQuota">Новое значение</label>
                                <input
                                    type="number"
                                    id="newQuota"
                                    style={newValueCss}
                                    defaultValue="0"
                                    disabled={isDisabledClose || isDisabledOpen}
                                />
                                <label
                                    htmlFor="closeQuota"
                                    style={{ margin: "0 5px 0 10px" }}
                                >
                                    Закрыть продажи
                                </label>
                                <input
                                    className={styles.inputDate}
                                    id="closeQuota"
                                    type="checkbox"
                                    onChange={handleCheckboxCloseChange}
                                    checked={isDisabledClose}
                                />
                                <label
                                    htmlFor="openQuota"
                                    style={{ margin: "0 5px 0 10px" }}
                                >
                                    Открыть продажи
                                </label>
                                <input
                                    className={styles.inputDate}
                                    id="openQuota"
                                    type="checkbox"
                                    onChange={handleCheckboxOpenChange}
                                    checked={isDisabledOpen}
                                />
                            </div>
                            <div style={{ marginTop: "20px" }}>
                                <Button
                                    onClick={props.onClose}
                                    color="primary"
                                    variant="contained"
                                    endIcon={<ArrowBackIcon />}
                                    style={{
                                        backgroundColor: orange[500],
                                        margin: "10px",
                                    }}
                                >
                                    Вернуться
                                </Button>
                                <Button
                                    color="primary"
                                    variant="contained"
                                    endIcon={<SaveIcon />}
                                    style={{
                                        backgroundColor: green[500],
                                        margin: "10px",
                                    }}
                                    type="submit"
                                >
                                    Сохранить
                                </Button>
                            </div>
                        </div>
                    </div>
                </form>
            </Dialog>
        </div>
    );
};

QuotaMassEditor.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    isVisible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default QuotaMassEditor;
